// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Oi7S_","choiceBoxes":"toolbarselects_choiceBoxes__1x60u","simpleField":"toolbarselects_simpleField__1ZVct"};